// extracted by mini-css-extract-plugin
export var filterIncDec = "_de-0";
export var leftBorder = "_de-1";
export var rightBorder = "_de-2";
export var stringInput = "_de-3";